import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const GateParkIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.9642 9.89113C20.0398 10.2118 19.9957 10.5143 19.8319 10.7965C19.7543 10.9334 19.6508 11.0532 19.5274 11.149C19.4039 11.2448 19.2629 11.3146 19.1127 11.3544L11.5091 13.4344L7.32828 14.5514L6.07886 14.9362L4 11.3352L5.15282 11.0273L6.70357 12.2213L10.6198 11.1812L7.36608 5.42327L8.87903 5L14.3072 10.1605L18.5268 9.02428C18.8418 8.93449 19.141 8.97618 19.4245 9.1504C19.708 9.32356 19.8886 9.57047 19.9642 9.89113ZM4.52916 17.3828H19.5274V19H4.52916V17.3828Z'
                fill='currentColor'
            />
        </>
    ),
})

GateParkIcon.displayName = 'GateParkIcon'
